/**
 * Biometric unlock (screen 9, `POST /auth/biometric/unlock`).
 *
 * Not a login: it re-opens a session this device already holds, so it is only
 * offered once a refresh token exists locally (backend-routes.md §3).
 * The web implementation is WebAuthn with a platform authenticator; Capacitor
 * will swap in the native biometric plugin behind the same interface.
 */
export interface BiometricsApi {
  isAvailable(): Promise<boolean>
  /** Resolves true when the user proved presence, false when they cancelled. */
  authenticate(reason: string): Promise<boolean>
}

export const webBiometrics: BiometricsApi = {
  async isAvailable() {
    const pk = globalThis.PublicKeyCredential
    if (!pk?.isUserVerifyingPlatformAuthenticatorAvailable) return false
    try {
      return await pk.isUserVerifyingPlatformAuthenticatorAvailable()
    } catch {
      return false
    }
  },
  async authenticate() {
    // A real challenge has to come from `/auth/biometric/unlock`; until that
    // screen is built this reports "not available" rather than faking success.
    return false
  },
}
